<template>
  <div></div>
</template>
<script>

import sy from "@/sy";


export default {
  name: "wechat",
  data() {
    return {};
  },
  created() {

    // 执行 参数获取
    // console.log(_this.$router.currentRoute.path);
    // http://localhost:8080/login?origin=aHR0cDovL2xvY2FsaG9zdDo4MDgwL2JpbmQ=
    // console.log(Base64.encode('http://localhost:8080/bind'));


	// 原理			页面从 A(带上参数) 到登录页  跳去微信  再把参数带回来


    // 参数情形
	// pageto        内部跳转过来的 非401过来 一般是首次登陆

    // to           微信回调时带回的
    // code         微信回调时给的
    // origin       微信回来的
 
	// 初次
    let pageto   = this.$router.currentRoute.query.pageto;
 
	// 二次
    let url_to   = this.$router.currentRoute.query.to;
    let url_code = this.$router.currentRoute.query.code;


	// 初次 无code 跳去拿 code
    if( url_code === undefined )
    {
        return sy.http.getCode(pageto);
    }

	// 若返回此参数说明已从微信跳转回来 解码
    if ( url_to )
    {
        let Base64 = require("js-base64").Base64;
        url_to = Base64.decode(url_to);
    } 
	
    // 承接 http.getCode(); 带回来的参数
	if( url_code && url_to )
	{
        let data =
        {
            'wxcode': url_code,
        }; 
		
		
        sy.http.get({
            url:  this.$root.API + 'Auth/WechatMp',
            data: data,
            success: function(res)
            {
                if( res.state === '1' )
                {
                    console.log('获取成功:' + res.data.utoken);

                    // 存储 utoken
                    localStorage.setItem('utoken',res.data.utoken);

                    // 回到源头
                    location.href=url_to;

                }else{
                    alert(res.msg);
                }
            }});

    }else{
        console.log('不讲伍德url_code + url_to丢失 ');
    }
  },
};
</script>